<template>
    <div id="cfsBatchUpdate">
        <a-modal v-model="visible" :title="titleText" @cancel="close">
            <template slot="footer">
                <!--v-if="orderType=='SCAN_IN'"-->
                <a-button  v-if="orderType=='SCAN_IN'" style="float: left" size="small" type="primary" @click="switchMissing">{{buttonText}}</a-button>
                <a-button size="small" type="primary" @click="save">{{ $t('publicLang.Confirm') }}</a-button>

            </template>
            <a-form :form="form" >
                <a-form-item :label="labelText"  v-bind="formItemLayout">
                    <a-input size="small" ref="inputTextRef" style="width: 80%" v-model="inputText" @pressEnter="save"/>
                </a-form-item>


            </a-form>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    export default{
        data(){
            return{
                inputText:'',
                uids: [],
                visible: false,
                cusSku:'',
                form:this.$form.createForm(this),
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                scanType:0, // 0 扫描毛领子条码 1 扫描缺失信息
                orderNo:'',
                orderType:'',

                titleText:'',
                labelText:'',
                buttonText:'',
            }
        },
        watch:{

        },
        methods:{
            /**
             * @param cusSku        毛领子条码
             * @param orderType     订单类型   SCAN_IN SCAN_PACK
             * @param orderNo       订单号
             */
            show(cusSku,orderType,orderNo){
                // SCAN_IN 可能会扫描缺失, SCAN_PACK不会
                this.cusSku = cusSku;
                this.orderType = orderType;
                this.orderNo = orderNo;
                this.visible = true;

                this.resetData();
                this.$nextTick(()=>{
                    this.$refs.inputTextRef.focus();
                })
            },
            save() {
                // 默认
                if(this.scanType == 0) {
                    // 扫描毛领子条码
                    let params = {}

                    if(this.inputText == '') {
                        return;
                    }
                    if(this.inputText != this.cusSku) {
                        this.$customMessage.warning(this.$t('collarBarcode.woolenCollarBarcodeMismatch'), 2);
                        return;
                    }

                    this.$emit("confirmCusSku");
                    this.visible = false;
                } else if(this.scanType == 1) {
                    // 扫描缺失

                    // 缺失内容为空时 直接返回
                    if(this.cusSku == undefined || this.cusSku == null || this.cusSku == '') {
                        this.$emit("confirmCusSku");
                        this.visible = false;
                        return;
                    }


                    let params = {
                        missText : this.inputText,
                        recId : this.orderNo
                    };

                    this.$emit("confirmCusSku",this.inputText);
                    this.visible = false;
                }

            },
            switchMissing() {
                // 切换缺失和毛领子
                if(this.scanType == 0) {
                    this.scanType = 1;

                    this.titleText=this.$t('collarBarcode.missing');
                    this.labelText=this.$t('collarBarcode.missing');
                    this.buttonText=this.$t('collarBarcode.woolenCollarBarcode');
                } else if(this.scanType == 1) {
                    this.scanType = 0;

                    this.titleText=this.$t('collarBarcode.woolenCollarBarcode');
                    this.labelText=this.$t('collarBarcode.woolenCollarBarcode');
                    this.buttonText=this.$t('collarBarcode.missing');
                }
                this.inputText = '';



            },
            resetData() {
                this.inputText = '';
                this.scanType = 0;

                this.titleText=this.$t('collarBarcode.woolenCollarBarcode');
                this.labelText=this.$t('collarBarcode.woolenCollarBarcode');
                this.buttonText=this.$t('collarBarcode.missing');
            },
            close() {
                this.$emit("cusSkuWindowClose");
                this.visible = false;
            },

        }
    }
</script>